// Live chat SupportBoxu místo Smartsuppu (supportbox-jipos #8, handover
// 2026-09-28): vlastní plovoucí tlačítko šablony + vstupy z obsahu (karta
// poradce a panel vyprodaného na detailu). Widget SupportBoxu se načte až na klik.
//
// PROČ takhle (návrh 2026-09-30):
// - Widget (iframe #supportBox-iframe: ~51 kB br JS, CSS, Open Sans z Google
//   Fonts, websocket) se nestahuje, dokud o chat nikdo nestojí. Stránka bez chatu
//   nenese kód třetí strany vůbec (rozhodnutí 22. 9. dávalo třetí strany až po
//   `load`, tohle je o krok dál) a SupportBox nedostává URL, titulek ani košík
//   návštěvníků, kteří chat neotevřeli (widget je posílá sám: LastVisitUrlSender
//   a ShoptetCustomerCartSender ve webChat.js). Harnessy proti dev tak SupportBox
//   nezaplaví návštěvami.
// - Widget běží skrytý (`supportBoxChatRunAsHidden`) a jeho kolečko nahrazuje
//   naše tlačítko: polohu nad BottomNav, sticky ATC i lištou vyprodaného řeší naše
//   CSS (_support-chat.scss), ne přebíjení inline stylu iframu (`bottom: 0`,
//   z-index 111000). Iframe je vidět jen s otevřeným oknem: `supportBox:view` →
//   show(), `supportBox:close` → hide().
// - Otevřené okno na desktopu je beze změny SupportBoxu (355×580 vpravo dole),
//   barvu nese nastavení chatu (#c0272e = --bs-c-primary, schválil Tomáš 28. 9.).
//   Mobil (přes celý viewport) má vlastní rozvržení uvnitř iframu
//   (supportChatFrame.js) a iframe drží viditelnou plochu nad klávesnicí
//   (`trackViewport`, Tomáš 2026-10-04: pole pod klávesnicí, patička přes pole,
//   okno šlo posouvat). Zámek scrollu widgetu (`body.sb_mobile`) se sbalenou lištou
//   prohlížeče dělal pruh nad a pod oknem; s přepínačem `chatKeepScroll` ho CSS ruší.
// - Kdo chatu napsal (posledních 7 dní) nebo nechal okno otevřené (desktop, stav
//   `supportboxChat_status` v localStorage widgetu), dostane widget po `load` na
//   každé stránce: odpověď operátora se ukáže tečkou na tlačítku a otevřené okno
//   zůstane otevřené i po přechodu na jinou stránku.
// - Přihlášený zákazník předvyplní e-mail a jméno (`supportBoxChatVariables`
//   z dataLayeru `customer`); podle e-mailu páruje agent Stav objednávky i panel
//   operátora. Telefon ani číselné id zákazníka dataLayer nenese. Nepřihlášený
//   dostane e-mail objednávky, kterou právě ověřil na stránce Stav objednávky
//   (`setChatContact`, číslo + e-mail): chat ze stránky pak nese kontakt a záchytná
//   síť má kam odpovědět (sonda 6. 10.: 7 z 58 chatů bez odpovědi i bez e-mailu,
//   handover supportbox 2026-10-09). Widget bere jen `email` a `fullName`: vlastní
//   klíč (zkoušené `orderCode`) SupportBox zahodí a agent Lucy proměnné nevidí vůbec
//   (sonda F supportboxu 9. 10.). Číslo a e-mail objednávky proto jdou do chatu
//   otevřeného klikem na stránce předvyplněnou zprávou (`fillComposer`); neodeslaný
//   předvyplněný text se při zavření okna i odchodu ze stránky smaže, jinak by ho
//   widget jako koncept vracel v chatu otevřeném kdekoli jinde.
// - Detail produktu předvyplní „Dotaz k produktu <název>: " (`setChatTopic`,
//   handover jipos-supportbox 2026-10-18): Lucy dostane k dotazu jen produkty
//   podobné jeho textu a zákazník na detailu píše „jaký je průměr magnetu?" bez
//   názvu. Na 27 skutečných chatech z detailu odpověděla o jiném produktu v 6, se
//   stejnou předponou v žádném. Jen do konverzace, která ještě nezačala: okno se
//   zprávou zákazníka (vrací se k chatu) dostane prázdné pole jako dřív.
// - Se zapnutým chatem se nenačte Smartsupp (doplněk ostré): jeho loader vkládá
//   hlavička až po `load` a jen s `_smartsupp.key`, který tu smažeme. Výměna je tak
//   v okamžiku deploye, ne až po vypnutí doplňku klientem. Výjimka: spojení, kde
//   bundle doběhne až po 5s pojistce hlavičky — tam Smartsupp naskočí, dokud
//   klient doplněk nevypne.
//
// Přepínač `supportChat` (features.js) je zapnutý všude, ostrá od 3. 10. 2026
// (souhlas Tomáše). Bez přepínače i bez `chat` v manifestu (SK) modul nic
// nekreslí a nic nenačítá.
//
// Vstup do chatu odkudkoli = prvek s `data-bs-chat="<zdroj>"` (`asChatTrigger`,
// delegovaný klik na dokumentu). Sloty „Napište nám" (rozhodnutí Tomáše
// 2026-09-30): slot „zavolejte, jinak napište" `reachContact()` v headerTools.js
// (telefon → chat → e-mail), sdílené seznamy akcí přes `chatActions()`
// (poradna, CTA pás, hero stránky) a jednotlivé bloky (hlavička, patička,
// kontakt, doprava, stav objednávky). E-mail zůstává vedle jako druhá cesta;
// vstup je odkaz se záložním `mailto:` (Ctrl/prostřední tlačítko, výpadek JS).
// Karta odbornice u FAQ produktu a Retino chat nemají (formulář, reklamace).

import L from '../locale/cs/supportChat.js';
import SHOP from '../../config/shop.js';
import { featureOn } from './features.js';
import { icon } from './icon.js';
import { shoptetData } from '../shoptet-hooks.js';
import { showFeedback } from './feedbackToast.js';
import { clearComposer, fillComposer, keepAtBottom, refitComposers, styleFrame } from './supportChatFrame.js';

// e-mail z manifestu, ne `CONTACT` z headerTools.js — ten čte chat
// (`reachContact`), import zpátky by byl kruh
const EMAIL = SHOP.contact.email;

export const ENTRY_POINT = 'https://chat.supportbox.cz/web-chat/entry-point';
const LOAD_TIMEOUT_MS = 15000;
// po otevření čekáme na `supportBox:view`; když nepřijde (okno bylo otevřené už
// z minula), ukážeme iframe i tak — klik nesmí zůstat bez odezvy
const REVEAL_FALLBACK_MS = 3000;
// odpověď operátora může přijít i po víkendu (pracovní doba chatu Po–Pá)
export const ACTIVE_KEY = 'bs-chat-active';
export const ACTIVE_MS = 7 * 24 * 3600 * 1000;
// stav okna, který si widget drží sám (webChat.js ChatBoxStatePersister);
// mobil ho widget ignoruje a otevírá vždy zavřený
export const WIDGET_STATUS_KEY = 'supportboxChat_status';
// DeviceDetector webChat.js (= $bp-md šablony): do 768 px je okno přes celý viewport
const MOBILE_MAX = 768;

let widget = null; // Promise<supportBoxApi>
let injected = false;
let opened = false;
// open() widgetu přepíná okno asynchronně: druhé volání dřív, než stav doběhne
// (dvojklik), by okno hned zase zavřelo
let opening = false;
let launcher = null;
// další stálé vstupy s tečkou nepřečtené odpovědi (položka Chat spodní lišty)
const launchers = [];
let lastTrigger = null;
let initDone = false;
// e-mail objednávky ověřené na stránce Stav objednávky (`setChatContact`)
let contact = '';
// zpráva předvyplněná do okna otevřeného klikem (`setChatContact`), `filled` = text,
// který právě leží v poli a nikdo ho nezměnil
let draft = '';
// téma chatu stránky (`setChatTopic`, detail produktu): jako `draft`, ale jen do
// konverzace bez zprávy zákazníka
let topic = '';
let wantDraft = false;
let filled = '';

/** `{ id, secret }` chatu z manifestu shopu, jinak `null`. */
export function chatConfig(shop) {
  const c = (shop || SHOP).chat;
  return c && c.supportBoxId && c.supportBoxSecret ? { id: c.supportBoxId, secret: c.supportBoxSecret } : null;
}

/** Chat na téhle stránce: shop ho má a přepínač `supportChat` ho pouští. */
export function chatOn() {
  return !!chatConfig() && featureOn('supportChat');
}

// Widget skládá hodnoty do `value="…"` řetězcem bez escapování — uvozovka ve
// jméně by rozbila jeho formulář.
function clean(v) {
  return typeof v === 'string' ? v.replace(/["<>]/g, '').trim() : '';
}

/**
 * Předvyplnění identity (`supportBoxChatVariables`): přihlášený zákazník
 * s e-mailem (a jménem), jinak e-mail ověřené objednávky ze stránky Stav
 * objednávky (`contactEmail`), jinak `null`. Bez nich proměnná nevznikne vůbec
 * (vzorové hodnoty z implementačního kódu SupportBoxu na web nesmí). Přihlášený
 * má přednost, ať se jméno jednoho a e-mail druhého nesejdou v jednom kontaktu.
 */
export function chatVariables(customer, contactEmail) {
  const email = customer && customer.registered === true ? clean(customer.email) : '';
  if (email) {
    const vars = { email };
    const name = clean(customer.fullName);
    if (name) vars.fullName = name;
    return vars;
  }
  const other = clean(contactEmail);
  return other ? { email: other } : null;
}

/**
 * E-mail objednávky, kterou návštěvník právě ověřil na stránce Stav objednávky
 * (číslo + e-mail sedí, API vrátilo stav). Widget ho dostane jen při načtení,
 * tedy když chat ještě neběží. `message` = text, který se předvyplní do pole
 * okna otevřeného klikem (číslo a e-mail objednávky), i když chat už běží.
 * Prázdný e-mail zahodí obojí (jiné hledání, chyba).
 */
export function setChatContact(email, message) {
  contact = typeof email === 'string' ? email : '';
  draft = contact && typeof message === 'string' ? message : '';
}

/**
 * Text, který se předvyplní do pole okna otevřeného klikem na téhle stránce
 * (detail produktu: „Dotaz k produktu <název>: "), jen když konverzace ještě
 * nezačala. Zpráva `setChatContact` má přednost. Prázdný text téma zruší.
 */
export function setChatTopic(message) {
  topic = typeof message === 'string' ? message : '';
}

// Předvyplnění jen po kliku (`openChat`), ne u okna otevřeného z minula po načtení.
// Téma stránky jen do nové konverzace: zpráva zákazníka v okně (`fillComposer` fresh),
// nebo náš záznam, že psal posledních 7 dní. Historie zpráv se v okně vykreslí až
// s odpovědí serveru, třeba až po předvyplnění.
function applyDraft() {
  if (!wantDraft) return;
  wantDraft = false;
  const text = draft || (wroteRecently(readStore, Date.now()) ? '' : topic);
  if (text && fillComposer(frameEl(), text, !isMobile(), !draft)) filled = text;
}

/** Zákazník chatu napsal posledních 7 dní (`supportBox:message:send`). */
export function wroteRecently(read, now) {
  const last = Number(read(ACTIVE_KEY)) || 0;
  return last > 0 && now - last < ACTIVE_MS;
}

function dropDraft() {
  if (!filled) return;
  clearComposer(frameEl(), filled);
  filled = '';
}

/**
 * Načíst widget hned po `load`? Rozepsaná konverzace (zákazník psal posledních
 * 7 dní) nebo okno otevřené při odchodu ze stránky (jen desktop).
 */
export function wantsEarlyLoad(read, now, mobile) {
  const status = read(WIDGET_STATUS_KEY);
  if (!mobile && (status === 'open' || status === 'welcome')) return true;
  return wroteRecently(read, now);
}

/** Smartsupp doplňku ostré se nenačte (hlavička vkládá loader jen s klíčem). */
export function silenceSmartsupp(win) {
  const s = win && win._smartsupp;
  if (s && s.key) s.key = null;
}

function storage() {
  try {
    return window.localStorage;
  } catch (e) {
    return null; // blokované úložiště (Chrome „Blokovat všechny cookies")
  }
}

function readStore(key) {
  const s = storage();
  try {
    return s ? s.getItem(key) : null;
  } catch (e) {
    return null;
  }
}

function writeStore(key, value) {
  const s = storage();
  try {
    if (s) s.setItem(key, value);
  } catch (e) { /* bez úložiště jen bez předčasného načtení */ }
}

// `window.innerWidth` vynucuje synchronní layout. `initSupportChat` běží na konci bootu,
// takže prohlížeč kvůli němu přepočítal celou přestavěnou stránku ještě ve stavu kostry
// a po odkrytí znovu: 346 ms z 493 ms bootu detailu při CPU 4× (profil 2026-10-13,
// ops/sweeps/2026-10-13-lcp-kostra/boot-profile.mjs). MediaQueryList vyhodnotí prohlížeč
// bez reflow (vzor homepage.js); lazy kvůli importu modulu v Node (unit testy).
let mqMobile;
function isMobile() {
  if (mqMobile === undefined) {
    mqMobile = window.matchMedia ? window.matchMedia('(max-width: ' + MOBILE_MAX + 'px)') : null;
  }
  return mqMobile ? mqMobile.matches : window.innerWidth <= MOBILE_MAX;
}

function loadWidget() {
  if (widget) return widget;
  const cfg = chatConfig();
  widget = new Promise(function (resolve, reject) {
    if (window.supportBoxApi) {
      resolve(window.supportBoxApi);
      return;
    }
    const timer = setTimeout(function () {
      reject(new Error('supportBox timeout'));
    }, LOAD_TIMEOUT_MS);
    window.addEventListener(
      'supportBox:api:initialized',
      function () {
        clearTimeout(timer);
        resolve(window.supportBoxApi);
      },
      { once: true }
    );
    // pomalé spojení po timeoutu: skript už stojí, druhý by vyrobil druhý widget
    if (injected) return;
    injected = true;
    window.supportBoxChatId = cfg.id;
    window.supportBoxChatSecret = cfg.secret;
    window.supportBoxChatRunAsHidden = true;
    const vars = chatVariables(shoptetData('customer'), contact);
    if (vars) window.supportBoxChatVariables = vars;
    const s = document.createElement('script');
    s.src = ENTRY_POINT;
    s.async = true;
    s.onerror = function () {
      clearTimeout(timer);
      injected = false;
      s.remove();
      reject(new Error('supportBox load'));
    };
    document.head.appendChild(s);
  });
  // chyba = příští klik zkusí znovu
  widget.then(watchIframe, function () {
    widget = null;
  });
  return widget;
}

// Zavřené okno widgetu = iframe ve velikosti vlastní bubliny (IframeSizeCalculator
// webChat.js: 85×100), otevřené je 355×580 nebo přes celý viewport.
const CLOSED_MAX_W = 120;
const CLOSED_MAX_H = 140;
let watched = null;

// Křížek uvnitř okna (✕ v hlavičce i spodní bublina) okno zavře BEZ eventu
// `supportBox:close` — ten posílá jen `supportBoxApi.close()`. Šablona by o zavření
// nevěděla: iframe by zůstal viditelný s vlastní bublinou SupportBoxu přes BottomNav
// a naše kolečko schované (iPhone Tomáše 3. 10. 2026, chat na ostré stažen #483).
// Zavření proto poznáváme i podle velikosti iframu: jen PŘECHOD z okna na bublinu
// (otevírání může chvíli stát na malé velikosti, naše show/hide mění jen visibility).
function isBubble(f) {
  const w = parseFloat(f.style.width);
  const h = parseFloat(f.style.height);
  return w > 0 && h > 0 && w <= CLOSED_MAX_W && h <= CLOSED_MAX_H;
}

function frameEl() {
  return watched || document.getElementById('supportBox-iframe');
}

function watchIframe(api) {
  const f = (api && api.getIframe && api.getIframe()) || document.getElementById('supportBox-iframe');
  if (!f || f === watched) return;
  watched = f;
  // mobilní rozvržení okna (supportChatFrame.js); `load` = dopsaný dokument iframu
  styleFrame(f, document.documentElement);
  f.addEventListener('load', function () {
    styleFrame(f, document.documentElement);
  });
  if (typeof MutationObserver === 'undefined') return;
  let wasWindow = !isBubble(f);
  new MutationObserver(function () {
    const bubble = isBubble(f);
    if (bubble && wasWindow && opened) onWidgetClosed();
    wasWindow = !bubble;
  }).observe(f, { attributes: true, attributeFilter: ['style'] });
}

// Mobil: okno = viditelná plocha. Klávesnice iOS (a Chrome na Androidu) zmenší
// jen visualViewport; iframe s `position: fixed` a výškou `clientHeight`, kterou
// mu widget nastaví, by pod ní nechal pole a šel by s viditelnou plochou posouvat.
// Iframe proto nese rozměry a posun visualViewport jako proměnné, které čte
// _support-chat.scss (s !important, ať je nepřebije inline velikost widgetu
// z každého `resize`).
let vvTracked = false;

function syncViewport() {
  const vv = window.visualViewport;
  const f = frameEl();
  if (!vv || !f) return;
  keepAtBottom(f, function () {
    f.style.setProperty('--bs-chat-vv-top', vv.offsetTop + 'px');
    f.style.setProperty('--bs-chat-vv-left', vv.offsetLeft + 'px');
    f.style.setProperty('--bs-chat-vv-w', vv.width + 'px');
    f.style.setProperty('--bs-chat-vv-h', vv.height + 'px');
  });
}

function trackViewport(on) {
  const vv = window.visualViewport;
  if (!vv || on === vvTracked) return;
  vvTracked = on;
  const method = on ? 'addEventListener' : 'removeEventListener';
  vv[method]('resize', syncViewport);
  vv[method]('scroll', syncViewport);
  if (on) syncViewport();
}

function setOpen(on) {
  opened = on;
  opening = false;
  document.documentElement.classList.toggle('bs-chat-open', on);
  if (on) {
    setUnread(false);
    // okno vykreslí widget až po `supportBox:view`
    setTimeout(applyDraft, 0);
  }
  const mobile = on && isMobile();
  trackViewport(mobile);
  if (mobile) {
    styleFrame(frameEl(), document.documentElement);
    // pole s rozepsaným textem z minula (widget ho vrací z úložiště)
    setTimeout(function () {
      refitComposers(frameEl());
    }, 0);
  }
}

function reveal(api) {
  if (!api.isShow()) api.show();
  setOpen(true);
}

/** Stálý vstup do chatu, který nese tečku nepřečtené odpovědi (bottomNav.js). */
export function registerLauncher(el) {
  if (el && launchers.indexOf(el) < 0) launchers.push(el);
}

function setUnread(on) {
  if (launcher) {
    launcher.classList.toggle('is-unread', on);
    launcher.setAttribute('aria-label', on ? L.unread : L.open);
  }
  launchers.forEach(function (el) {
    el.classList.toggle('is-unread', on);
    // viditelný popisek „Chat" stačí, s odpovědí ji řekne i čtečce
    if (on) el.setAttribute('aria-label', L.unread);
    else el.removeAttribute('aria-label');
  });
}

// Počet nepřečtených drží widget ve svém (skrytém) kolečku — čte se odtud, ať
// tečka sedí s jeho logikou přečtení (historie zpráv při načtení vysílá
// `supportBox:message:receive` taky). Jiný tvar widgetu = prostě bez tečky.
function syncUnread() {
  if (opened) return;
  let n = 0;
  try {
    const f = document.getElementById('supportBox-iframe');
    const el = f && f.contentWindow.document.querySelector('.init-button__unread-messages');
    if (el && !el.classList.contains('hidden')) n = parseInt(el.textContent, 10) || 0;
  } catch (e) { /* bez přístupu do iframu bez tečky */ }
  setUnread(n > 0);
}

function busy(on) {
  [launcher, lastTrigger].forEach(function (el) {
    if (!el) return;
    el.classList.toggle('is-loading', on);
    if (on) el.setAttribute('aria-busy', 'true');
    else el.removeAttribute('aria-busy');
  });
}

/** Otevře chat (načte widget, když ještě není). `false` = chat tu není nebo selhal. */
export function openChat() {
  if (!chatOn()) return Promise.resolve(false);
  busy(true);
  return loadWidget().then(
    function (api) {
      busy(false);
      if (opened || opening) return true;
      opening = true;
      wantDraft = true;
      api.open();
      // `view` ani `close` nepřišly = okno bylo otevřené už z minula
      setTimeout(function () {
        if (opening) reveal(api);
      }, REVEAL_FALLBACK_MS);
      return true;
    },
    function () {
      busy(false);
      showFeedback(L.failed(EMAIL), 'error');
      return false;
    }
  );
}

/** Udělá z prvku vstup do chatu (delegovaný klik). `false` = chat tu není. */
export function asChatTrigger(el, source) {
  if (!el || !chatOn()) return false;
  el.setAttribute('data-bs-chat', source);
  el.setAttribute('aria-haspopup', 'dialog');
  return true;
}

/** Záložní href vstupu do chatu (výpadek JS, Ctrl/prostřední tlačítko). */
export function chatFallbackHref() {
  return 'mailto:' + EMAIL;
}

/**
 * Seznam akcí sdíleného panelu podle chatu. `{ chat: '<zdroj>' }` = vstup do
 * chatu, vznikne jen se zapnutým chatem (doplní se popisek, ikona a záložní
 * href); `chatless: true` = jen bez chatu (to, co chat nahrazuje);
 * `chatVariant` = varianta tlačítka se zapnutým chatem (ustoupí vstupu).
 * Builder prvek akce s `chat` předá `asChatTrigger`.
 */
export function chatActions(list, on) {
  const chat = on === undefined ? chatOn() : on;
  return list
    .filter(function (a) {
      return a && (chat ? !a.chatless : !a.chat);
    })
    .map(function (a) {
      if (a.chat) return Object.assign({ href: chatFallbackHref(), label: L.cta, icon: 'chat' }, a);
      if (chat && a.chatVariant) return Object.assign({}, a, { variant: a.chatVariant });
      return a;
    });
}

function onTriggerClick(e) {
  const t = e.target && e.target.closest ? e.target.closest('[data-bs-chat]') : null;
  if (!t) return;
  // Ctrl/Cmd/prostřední tlačítko nad odkazem = jeho vlastní href
  if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
  e.preventDefault();
  lastTrigger = t === launcher ? null : t;
  openChat();
}

function onWidgetClosed() {
  if (window.supportBoxApi && window.supportBoxApi.isShow()) window.supportBoxApi.hide();
  dropDraft();
  setOpen(false);
  // fokus zpátky tam, odkud chat vzešel (klávesnice, čtečka)
  const back = lastTrigger && lastTrigger.isConnected ? lastTrigger : launcher;
  if (back) {
    try {
      back.focus({ preventScroll: true });
    } catch (err) { /* starý prohlížeč bez options */ }
  }
}

function bindWidgetEvents() {
  window.addEventListener('supportBox:view', function () {
    if (window.supportBoxApi) reveal(window.supportBoxApi);
  });
  window.addEventListener('supportBox:close', onWidgetClosed);
  window.addEventListener('supportBox:message:send', function () {
    writeStore(ACTIVE_KEY, String(Date.now()));
    // odeslaný text pole vyprázdní widget sám
    filled = '';
    // widget pole po odeslání vyprázdní bez `input` → zpátky na jeden řádek
    setTimeout(function () {
      refitComposers(frameEl());
    }, 50);
  });
  window.addEventListener('supportBox:message:receive', function () {
    setTimeout(syncUnread, 300);
  });
  // odchod ze stránky s otevřeným oknem: koncept by se vrátil na další stránce
  window.addEventListener('pagehide', dropDraft);
}

function buildLauncher() {
  const btn = document.createElement('button');
  btn.type = 'button';
  btn.className = 'bs-chat-fab';
  btn.setAttribute('aria-label', L.open);
  btn.setAttribute('data-bs-chat', 'launcher');
  btn.setAttribute('aria-haspopup', 'dialog');
  btn.appendChild(icon('chat', 'bs-chat-fab__icon'));
  const dot = document.createElement('span');
  dot.className = 'bs-chat-fab__dot';
  dot.setAttribute('aria-hidden', 'true');
  btn.appendChild(dot);
  document.body.appendChild(btn);
  return btn;
}

function afterLoad(fn) {
  const idle = function () {
    if (window.requestIdleCallback) window.requestIdleCallback(fn, { timeout: 2000 });
    else setTimeout(fn, 1);
  };
  if (document.readyState === 'complete') idle();
  else window.addEventListener('load', idle, { once: true });
}

function preload() {
  loadWidget().then(
    function (api) {
      const status = readStore(WIDGET_STATUS_KEY);
      if (!isMobile() && (status === 'open' || status === 'welcome')) reveal(api);
      setTimeout(syncUnread, 300);
    },
    function () { /* tichý pokus, klik zkusí znovu */ }
  );
}

export function initSupportChat() {
  if (initDone || !chatOn()) return;
  initDone = true;
  silenceSmartsupp(window);
  // mobilní okno bez zámku scrollu widgetu (_support-chat.scss, přepínač chatKeepScroll)
  if (featureOn('chatKeepScroll')) document.documentElement.classList.add('bs-chat-keep-scroll');
  document.addEventListener('click', onTriggerClick);
  bindWidgetEvents();
  // pokladna: plovoucí tlačítko by leželo přes souhrn a CTA lištu (jako BottomNav)
  if (!document.body.classList.contains('ordering-process')) launcher = buildLauncher();
  if (wantsEarlyLoad(readStore, Date.now(), isMobile())) afterLoad(preload);
}
